export const PathType = {
    single_productNumber: 'single_productNumber' as const,
    single_order: 'single_order' as const,
    catalog_productNumber: 'catalog_productNumber' as const,
    catalog_order: 'catalog_order' as const,
    plusstore_productNumber: 'plusstore_productNumber' as const,
    plusstore_order: 'plusstore_order' as const,
    single_review: 'single_review' as const,
    catalog_review: 'catalog_review' as const,
} as const;

export const PathTypeString = {
    single_productNumber: '전체 상품번호를 입력해주세요!' as const,
    single_order: '전체 구매링크를 입력해주세요!' as const,
    catalog_productNumber: '전체 상품번호를 입력해주세요!' as const,
    catalog_order: '전체 구매링크를 입력해주세요!' as const,
    plusstore_productNumber: '전체 상품번호를 입력해주세요.\n플러스 스토어 앱 설치 필수!' as const,
    plusstore_order: '전체 구매링크를 입력해주세요.\n플러스 스토어 앱 설치 필수!' as const,

    single_review: '리뷰링크를 입력하는 미션입니다.' as const,
    catalog_review: '리뷰링크를 입력하는 미션입니다.' as const,
} as const;

export const PathTypeStringVer2 = {
    single_productNumber: '전체 상품번호를\n입력해주세요!' as const,
    single_order: '전체 구매링크를\n입력해주세요!' as const,
    catalog_productNumber: '전체 상품번호를\n입력해주세요!' as const,
    catalog_order: '전체 구매링크를\n입력해주세요!' as const,
    plusstore_productNumber: '전체 상품번호를\n입력해주세요.\n플러스 스토어 앱 설치 필수!' as const,
    plusstore_order: '전체 구매링크를 입력해 주세요.\n플러스 스토어 앱 설치 필수!' as const,

    single_review: '전체 리뷰링크를\n입력해주세요!' as const,
    catalog_review: '전체 리뷰링크를\n입력해주세요!' as const,
} as const;

export const PathTypePlaceHolderString = {
    single_productNumber: '전체 상품번호 입력' as const,
    single_order: '전체 URL 입력' as const,
    catalog_productNumber: '전체 상품번호 입력' as const,
    catalog_order: '전체 URL 입력' as const,
    plusstore_productNumber: '전체 상품번호 입력' as const,
    plusstore_order: '전체 URL 입력' as const,

    single_review: '전체 URL 입력' as const,
    catalog_review: '전체 URL 입력' as const,
} as const;

export type PathTypesType = typeof PathType[keyof typeof PathType];